import { Calendar } from "primereact/calendar"
import { Dropdown } from "primereact/dropdown"
import { InputNumber } from "primereact/inputnumber"
import { useEffect, useState } from "react";
import { getClientes, getEstructura, getOperadores, getProveedores, getRutas } from "../integracion";
import { Button } from "primereact/button";


const Filtros = ({ filters, setFilters,onClick,onClean }) => {
    const [proveedores, setProveedores] = useState([])
    const [clientes, setClientes] = useState([])
    const [rutas, setRutas] = useState([])
    const [estructuras, setEstructuras] = useState([])
    const [operadores, setOperadores] = useState([])
    // trae todos los options de los inputs
    useEffect(() => {
        const getSelectsOptions = async () => {
            await getProveedores(setProveedores)
            await getClientes(setClientes)
            await getOperadores(setOperadores)
        }
        getSelectsOptions()
    }, [])
    useEffect(() => {
        if (filters.cliente) {
            const getRutasOptions = async () => {
                await getRutas(filters.cliente.code, setRutas)
            }
            getRutasOptions()
        }
    }, [filters.cliente])
    useEffect(() => {
        if (filters.ruta) {
            const getEstructuraOptions = async () => {
                await getEstructura(filters.ruta.code, setEstructuras)
            }
            getEstructuraOptions()
        }
    }, [filters.ruta])
    return (
      <div className="bitacoras-filtros">
            <div className="grupo-filtro">
                <label>ID</label>
                <InputNumber value={filters.id} onValueChange={(e) => setFilters({ ...filters, id: e.value })} inputClassName="w-full" useGrouping={false} />
            </div>
            <div className="grupo-filtro">
                <label>Desde</label>
                <Calendar value={filters.desde} onChange={(e) => setFilters({ ...filters, desde: e.value })} dateFormat="dd/mm/yy" showIcon className="w-full" />
            </div>
            <div className="grupo-filtro">
                <label>Hasta</label>
                <Calendar value={filters.hasta} onChange={(e) => setFilters({ ...filters, hasta: e.value })} dateFormat="dd/mm/yy" showIcon className="w-full" />
            </div>
            <div className="grupo-filtro">
                <label>Proveedor</label>
                <Dropdown value={filters.proveedor} onChange={(e) => setFilters({ ...filters, proveedor: e.value })} options={proveedores} optionLabel="name" className="w-full" placeholder="Proveedor" filter />
            </div>
            <div className="grupo-filtro">
                <label>Cliente</label>
                <Dropdown value={filters.cliente} onChange={(e) => setFilters({ ...filters, cliente: e.value })} options={clientes} optionLabel="name" className="w-full" placeholder="Cliente" filter />
            </div>
            <div className="grupo-filtro">
                <label>Ruta</label>
                <Dropdown value={filters.ruta} onChange={(e) => setFilters({ ...filters, ruta: e.value })} options={rutas} optionLabel="name" className="w-full" placeholder="Ruta" filter />
            </div>
            <div className="grupo-filtro">
                <label>Estructura</label>
                <Dropdown value={filters.estructura} onChange={(e) => setFilters({ ...filters, estructura: e.value })} options={estructuras} optionLabel="name" className="w-full" placeholder="Estructura" filter />
            </div>
            <div className="grupo-filtro">
                <label>Operador</label>
                <Dropdown value={filters.operador} onChange={(e) => setFilters({ ...filters, operador: e.value })} options={operadores} optionLabel="name" className="w-full" placeholder="Operador" filter />
            </div>
            <div className="grupo-filtro">
                <label>Unidad</label>
                <InputNumber value={filters.unidad} onValueChange={(e) => setFilters({ ...filters, unidad: e.value })} inputClassName="w-full" />
            </div>

            <div className="grupo-filtro buttons-flex" >
                <Button severity="primary" icon="pi pi-search" label="BUSCAR" onClick={onClick} />
                <Button severity="secondary"  label="LIMPIAR" onClick={onClean} />
            </div>
        </div>
    )
}
export default Filtros